(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-offers"] && !Shopify.designMode) return;
  try {
    let scrollContainer = document.querySelector(".offer-blocks-container");
    let nextBtn = document.getElementById("nextBtn");
    let backBtn = document.getElementById("backBtn");
    let dotsContainer = document.querySelector(".pagination-dots");

    // Grab all items
    let items = scrollContainer.querySelectorAll(".offer-block");

    // Calculate width of one item (with margin)
    let item = items[0];
    let itemStyle = getComputedStyle(item);
    let itemMargin = parseInt(itemStyle.marginRight);
    let itemWidth = item.offsetWidth + itemMargin;

    // Current index
    let currentIndex = 0;

    // Create dots
    items.forEach((_, i) => {
      let dot = document.createElement("span");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active"); // first dot active
      dot.dataset.index = i; // store index
      dotsContainer.appendChild(dot);
    });

    let dots = dotsContainer.querySelectorAll(".dot");

    // Update active dot
    function updateDots(index) {
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    // Go to specific item
    function goToIndex(index) {
      currentIndex = index;
      scrollContainer.scrollLeft = currentIndex * itemWidth;
      updateDots(currentIndex);
    }

    // Next button (with loop)
    nextBtn.addEventListener("click", () => {
      if (currentIndex >= items.length - 1) {
          goToIndex(0); // loop back to first
      } else {
          goToIndex(currentIndex + 1);
      }
    });

    // Back button (with loop)
    backBtn.addEventListener("click", () => {
      if (currentIndex <= 0) {
          goToIndex(items.length - 1); // loop to last
      } else {
          goToIndex(currentIndex - 1);
      }
    });

    // Clicking a dot jumps directly
    dots.forEach(dot => {
      dot.addEventListener("click", () => {
          let index = parseInt(dot.dataset.index);
          goToIndex(index);
      });
    });

    document.querySelectorAll(".copypaste").forEach(function (copyPastew) {
      let cpnCode = copyPastew.querySelector(".cpnCode").innerHTML;
      let cpnBtn = copyPastew.querySelector(".cpnBtn");
      let cpnIcon = copyPastew.querySelector("#copy-svg");
        copyPastew.addEventListener("click", function () {
        navigator.clipboard.writeText(cpnCode).then(() => {
        cpnBtn.innerText = " 🧤Copied";
        cpnIcon.style.fill = "var(--block-title-bg)";
        setTimeout(function () {
            cpnBtn.innerText = " 🛍Enjoy";
        }, 5000);
        });
      });
    });
  } catch(e) { console.error(e); }
})();

})();
